import { render, staticRenderFns } from "./CarruselArchivosComponent.vue?vue&type=template&id=569bfd47&scoped=true&"
import script from "./CarruselArchivosComponent.vue?vue&type=script&lang=js&"
export * from "./CarruselArchivosComponent.vue?vue&type=script&lang=js&"
import style0 from "./CarruselArchivosComponent.vue?vue&type=style&index=0&id=569bfd47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569bfd47",
  null
  
)

export default component.exports